export default __webpack_public_path__ + "static/creative_get_inspried_left-931cbc20fd73f28b5b3d15ec67a0cfbf.svg";